import { adminInstance } from "@/api/instance";

export default async function (b4aId) {
  return adminInstance.delete(`/b4a/${b4aId}`);
}
